import { apiProxy, Payload } from './proxy.services';

const USER_MANAGEMENT_API = `${process.env.VUE_APP_USER_MANAGEMENT_API}`;

const OWNER_IDENTIFIER = process.env.VUE_APP_OWNER_IDENTIFIER;

export default {
    async getUsers(dealerIdentifier) {

        const options = new Payload(`${USER_MANAGEMENT_API}/${OWNER_IDENTIFIER}/Users/search`, 'POST', {
            "searchKeyword": "",
            "dealerIds": [
                dealerIdentifier
            ],
            "offset": 0,
            "limit": 100,
            "includeResults": true,
            "includeTotalCount": true
            });

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            if (error.response)
                throw new Error(error.response.data.customMessage || error.response.data.message);

            throw new Error(error);
        }
    }
};